var map = {
	"./favicon/android-chrome-192x192": 0,
	"./favicon/android-chrome-192x192.png": 0,
	"./favicon/android-chrome-384x384": 1,
	"./favicon/android-chrome-384x384.png": 1,
	"./favicon/android-chrome-512x512": 2,
	"./favicon/android-chrome-512x512.png": 2,
	"./favicon/apple-touch-icon": 3,
	"./favicon/apple-touch-icon.png": 3,
	"./favicon/browserconfig.xml": 40,
	"./favicon/favicon-16x16": 4,
	"./favicon/favicon-16x16.png": 4,
	"./favicon/favicon-32x32": 5,
	"./favicon/favicon-32x32.png": 5,
	"./favicon/favicon.ico": 41,
	"./favicon/manifest.json": 42,
	"./favicon/mstile-150x150": 6,
	"./favicon/mstile-150x150.png": 6,
	"./favicon/safari-pinned-tab": 7,
	"./favicon/safari-pinned-tab.svg": 7,
	"./login": 8,
	"./login.jpg": 8,
	"./login_mobile": 9,
	"./login_mobile.jpg": 9,
	"./patterns/circle-ocean": 10,
	"./patterns/circle-ocean.svg": 10,
	"./patterns/footer-desktop": 11,
	"./patterns/footer-desktop-nl": 12,
	"./patterns/footer-desktop-nl.svg": 12,
	"./patterns/footer-desktop.svg": 11,
	"./patterns/footer-leaf": 13,
	"./patterns/footer-leaf.svg": 13,
	"./patterns/footer-mobile": 14,
	"./patterns/footer-mobile-nl": 15,
	"./patterns/footer-mobile-nl.svg": 15,
	"./patterns/footer-mobile.svg": 14,
	"./patterns/oranges": 16,
	"./patterns/oranges.svg": 16,
	"./patterns/wrapper-bottom": 17,
	"./patterns/wrapper-bottom.svg": 17,
	"./patterns/wrapper-top": 18,
	"./patterns/wrapper-top.svg": 18,
	"./svgs/alert": 19,
	"./svgs/alert.svg": 19,
	"./svgs/close": 20,
	"./svgs/close.svg": 20,
	"./svgs/icon-alert": 21,
	"./svgs/icon-alert.svg": 21,
	"./svgs/icon-back": 22,
	"./svgs/icon-back.svg": 22,
	"./svgs/icon-caret": 23,
	"./svgs/icon-caret.svg": 23,
	"./svgs/icon-check": 24,
	"./svgs/icon-check.svg": 24,
	"./svgs/icon-dash": 25,
	"./svgs/icon-dash.svg": 25,
	"./svgs/icon-down-arrow": 26,
	"./svgs/icon-down-arrow.svg": 26,
	"./svgs/icon-facebook": 27,
	"./svgs/icon-facebook.svg": 27,
	"./svgs/icon-favourites-add": 28,
	"./svgs/icon-favourites-add.svg": 28,
	"./svgs/logo-small": 29,
	"./svgs/logo-small.svg": 29,
	"./svgs/logo-wide": 30,
	"./svgs/logo-wide.svg": 30,
	"./svgs/menu": 31,
	"./svgs/menu.svg": 31,
	"./svgs/pattern": 32,
	"./svgs/pattern.svg": 32,
	"./svgs/rays": 33,
	"./svgs/rays.svg": 33,
	"./svgs/star": 34,
	"./svgs/star.svg": 34,
	"./svgs/wave-shape": 35,
	"./svgs/wave-shape.svg": 35,
	"./svgs/wave-underline": 36,
	"./svgs/wave-underline.svg": 36
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 39;